import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function AgencyMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.contractor.home);
  };

  return (
    <MainMenuItem
      itemTitleString="代理・委託店の管理"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default AgencyMenuItem;
